import contract, { selectors } from '@mailobj-browser/front/js/contracts/contract.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import anchor from '#utilities/js/lightboxes/templates/anchor.js'
import button from '#utilities/js/lightboxes/templates/button.js'
import details from '#utilities/js/lightboxes/templates/details.js'
import label from '#utilities/js/lightboxes/templates/label.js'
import select from '#utilities/js/lightboxes/templates/select.js'

export default contract({
  [selectors]: {
    'a > template': array([
      anchor
    ]),
    'button > template': array([
      button
    ]),
    'details > template': array([
      details
    ]),
    'label > template': array([
      label
    ]),
    'select > template': array([
      select
    ])
  }
})
